import { JiraIssueTypeDTO } from './jira-issuetype.model';
import { JiraProjectDTO } from './jira-project.model';

export interface JiraLabelDTO {
  id?: string;
  name: string;
}
export interface JiraIssueDTO {
  key: string;
  issueType: JiraIssueTypeDTO;
  summary?: string;
  labels?: JiraLabelDTO[];
  project?: JiraProjectDTO;
  htmlDescription?: string;
}

export class JiraIssue {
  private readonly key: string;
  private readonly summary: string;
  private readonly labels: JiraLabelDTO[];
  private readonly project: JiraProjectDTO | undefined;
  private readonly issueType: JiraIssueTypeDTO;
  private readonly htmlDescription: string;

  static projectKey(key: string): string {
    const issueKeyParts = key.split('-');

    return issueKeyParts.length === 2 ? issueKeyParts[0] : '';
  }

  constructor({ key, summary, labels, project, issueType, htmlDescription }: JiraIssueDTO) {
    this.key = key;
    this.summary = summary || '';
    this.labels = labels || [];
    this.issueType = issueType;
    this.project = project ?? undefined;
    this.htmlDescription = htmlDescription ?? '';
  }

  getSummary(): string {
    return this.summary;
  }

  getKey(): string {
    return this.key;
  }

  getHtmlDescription(): string {
    return this.htmlDescription;
  }

  hasLabels(): boolean {
    return this.labels.length > 0;
  }

  getLabelNames(): string[] {
    return this.labels.map(lable => lable.name);
  }

  getProjectName(): string {
    return this.project?.name ?? '';
  }

  getProjectId(): string {
    return this.project?.id ?? '';
  }

  getIssueType(): JiraIssueTypeDTO {
    return this.issueType;
  }

  getIssueTypeName(): string {
    return this.issueType.name;
  }

  hasSameIssueType(issueType: JiraIssueTypeDTO): boolean {
    return this.issueType.name === issueType.name;
  }

  buildDescription(description: string): string {
    return `${this.key} ${description}`;
  }

  extractIssueKey(description: string): string {
    const parts = description.match(/[a-zA-Z]+-[0-9]+/);

    if (!parts?.length) return this.key;

    return parts[0];
  }

  extractProjectKey(): string {
    return JiraIssue.projectKey(this.key);
  }
}
